export default{name:"menu",computed:{LOCALE:function LOCALE(){return window.LOCALE},isVisible:function isVisible(){return this.$store.state.menuVisible},configurator:function configurator(){return this.$store.state.configurator}}};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./app/components/partials/Menu.vue
// module id = 276
// module chunks = 0